import { useEffect, useRef, useContext, useState } from "react"
import { GpraContext } from "../../../context/gpraContext"
import { endpoints } from "../../../config/gpraApiEndpoints"
import { showMessage } from "../utils/utils"
import FollowUp from "../Forms/I/FollowUp/FollowUp"
import { LoaderMedium } from "../../../components/Loaders"
import { INTERVIEW_SECTIONS } from "../types/interviewTypes"
import { UserContext } from "../../../context/userContext"

const FollowUpContainer = ({ showToolBar, disabled, interview_id }) => {
  const { interview, handleSubmitGet, handleLoadPrev, loadCollection } =
    useContext(GpraContext)
  const userCtx = useContext(UserContext)

  const [isGettingFollowUp, setIsGettingFollowUp] = useState(true)

  const toast = useRef()

  useEffect(() => {
    if (
      interview[INTERVIEW_SECTIONS.RECORD_MGMT].interview_id ||
      interview_id
    ) {
      setIsGettingFollowUp(true)
      handleSubmitGet(endpoints.GET_FOLLOWUP_DATA, {
        gpra_interview_id: interview_id
          ? interview_id
          : interview[INTERVIEW_SECTIONS.RECORD_MGMT].interview_id,
        organization_id: userCtx.session.user.organization_id,
        section: INTERVIEW_SECTIONS.FOLLOW_UP,
      })
        .then((response) => {
          loadCollection(setValues(response.data), INTERVIEW_SECTIONS.FOLLOW_UP)
          handleLoadPrev(false)
          setIsGettingFollowUp(false)
        })
        .catch((error) => {
          showMessage(false, error, toast)
          handleLoadPrev(false)
          setIsGettingFollowUp(false)
        })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const setValues = (data) => {
    return {
      gpra_i_1: data?.form?.gpraI1 ?? "",
      gpra_i_2: data?.form?.gpraI2 ?? "",
      gpra_i_2a: data?.form?.gpraI2a ?? "",
      gpra_i_3: data?.form?.gpraI3,
      gpra_i_id: data?.form?.gpraIId ?? 0,
      additional: data?.additional,
    }
  }
  if (isGettingFollowUp) {
    return <LoaderMedium></LoaderMedium>
  }
  return (
    <>
      {!isGettingFollowUp && (
        <FollowUp showToolBar={showToolBar} disabled={disabled} />
      )}
    </>
  )
}
export default FollowUpContainer
